import { useQuery } from 'react-query'
import { getContactGroup } from '../../../api/GET/contactGroup'

export const useQueryContactGroup = () => {
  return useQuery({
    queryKey: 'contactGroups',
    queryFn: getContactGroup,
    staleTime: 0,
    onError: (err) => {},
  })
}
